import { StateToken } from '@ngxs/store';
import { IReportingState } from './reporting.state';

export const REPORTING_STATE_TOKEN = new StateToken<IReportingState>('reporting');
